import React, { useEffect, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardText,
    FormGroup,
    Form,
    Input,
    Row,
    Col
} from "reactstrap";
import { auth } from '../../firebase/firebase-config';
import firebase from '../../firebase/firebase-config';
import { Link, useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast, Toast, ToastContainer } from 'react-toastify';

const SingleOrderProductView = () => {
    const params = useParams();

    const [user, loading] = useAuthState(auth);
    const [product_data, setproduct_data] = useState({});
    const [mydate, setdate] = useState();
    const [order_user, setorder_user] = useState({});
    const [hashtags, sethashtags] = useState([]);
    const [productImage, setProductImage] = useState([]);
    useEffect(() => {
        GetMyUser();


    }, [])
    async function GetMyUser() {
        try {
            console.log(params.id);

            firebase.firestore().collection('post').doc(params.id).onSnapshot((snapshot) => {
                console.log(snapshot.data());

                // const dates = new Date(snapshot.data()['date'].);
                const user_id = snapshot.data()['addedById'];
                const primg = snapshot.data()['media'];
                // const all_products = snapshot.data()['products'];

                // setdate(dates.toUTCString());
                setproduct_data(snapshot.data());
                setProductImage(snapshot.data()['media'])
                var mytags = [];
                snapshot.data()['hashTags'].forEach((tag) => {
                    mytags.push(tag);
                })
                sethashtags(mytags);

                firebase.firestore().collection('users').doc(user_id).onSnapshot((data) => {
                    setorder_user(data.data());

                })
            })





        } catch (error) {
            console.log(error);
        }



    }

    useEffect(() => {


    }, [])


    // console.log(Order_data);






    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12" className="shadow-lg  rounded">
                        <Card>
                            <CardHeader>
                                <h5 className="title display-4">Product Details  - </h5>
                                <h5>Product Created On : </h5>
                                <FormGroup>
                                    <label className=" font-weight-bold">Product Title : </label>
                                    <Link><h3 className=" font-weight-bold " style={{ cursor: 'pointer' }}> {product_data?.title} </h3></Link>

                                </FormGroup>
                                <div class="d-flex justify-content-between   rounded p-2" >
                                    <div style={{ height: '600px' }}>
                                        <img src={productImage[0]} className="img-fluid shadow-lg" loading='lazy' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                                    </div>
                                </div>

                            </CardHeader>
                            <CardBody>
                                <p className="display-5 font-weight-bold"> </p>
                                <Row>
                                    <Col className="pr-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Product Owner Name : </label>
                                            <label className=" ">{product_data?.addedByName} -- ID: {product_data?.addedById} </label>

                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer Email :</label>
                                            <label className=" ">{product_data?.addedByEmail}</label>

                                        </FormGroup>


                                        <FormGroup>
                                            <label className=" font-weight-bold">Product Category :</label>
                                            <label className=" ">{product_data?.category}</label>

                                        </FormGroup>
                                        <FormGroup className='d-flex'>
                                            <label className=" font-weight-bold">Product Hashtags :</label>
                                            {hashtags.map((mytgs, i) => {
                                                return <p key={i} className=" font-weight-bold px-3 py-1 ml-1" style={{ borderRadius: '12px', color: '#000000', backgroundColor: '#FFF' }}>#{mytgs}</p>
                                            })}
                                        </FormGroup>

                                    </Col>
                                    <Col className="px-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer User Name :</label>
                                            <Link to={`/admin/total-beyown-users/single_user/`} ><label className=" font-weight-bold" style={{ cursor: 'pointer' }}> @{order_user.username} -- {order_user.fullName} </label></Link>


                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Payment Method :</label>

                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Product Description : {product_data?.description}</label>

                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Product Gender :</label>
                                            <label className=" ">{product_data?.gender}</label>

                                        </FormGroup>
                                        <FormGroup>
                                            <label className=" font-weight-bold">Product Discount :</label>
                                            <label className=" ">{product_data?.discount}</label>

                                        </FormGroup>




                                    </Col>


                                </Row>


                                <p className="display-5 font-weight-bold">Address/Location Details : </p>
                                <Row>
                                    <Col className="pr-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Customer Address :</label>
                                            <label className=" "></label>

                                        </FormGroup>
                                    </Col>
                                    <Col className="pr-md-1" md="6">
                                        <FormGroup>
                                            <label className=" font-weight-bold">Location :</label>
                                            <label className=" "> </label>

                                        </FormGroup>
                                    </Col>
                                </Row>

                                <p className="display-5 font-weight-bold">Product PDF : </p>
                                <div className='mt-4'>
                                    <Link to="" >PDF</Link>

                                </div>
                            </CardBody>
                            <CardFooter>
                                <p className='display-4 p-2 rounded border font-weight-bold'>Total Amount: {product_data?.price} AED /- </p>
                            </CardFooter>
                        </Card>
                    </Col>

                </Row>
            </div>
            <ToastContainer />

        </>
    )
}

export default SingleOrderProductView